import SiteHeader from '@pages/PublicTripOverview/SiteHeader'
import React from 'react'
import { config } from '../../config'
import { FooterCaption, Page } from './PublicShell.styles'

/**
 * The chrome every public `/shared/trips/...` page renders its happy path in:
 * cream page surface, the marketing `SiteHeader` (view-only pill + Get Orbit
 * CTA), and the shared footer caption. Extracted so the shell lives once across
 * all public pages — the overview, the itinerary, and the per-section detail
 * pages compose their own content (Container, CtaBand, back links) as children.
 *
 * Loading / unavailable / error branches deliberately do NOT use this shell —
 * they render on the bare `Page` surface (see `PublicSectionGate`), matching
 * the overview's original treatment.
 */
const PublicShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<Page>
		<SiteHeader getOrbitUrl={config.getOrbitUrl} />
		{children}
		<FooterCaption>Shared from Orbit · plan group trips together without the chaos</FooterCaption>
	</Page>
)

export default PublicShell
